import { render, staticRenderFns } from "./FooterGroup.vue?vue&type=template&id=1a5af387&"
import script from "./FooterGroup.vue?vue&type=script&lang=js&"
export * from "./FooterGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports